<div
  class="bg-color-black u-padding-40-0"
  [ngStyle]="{ 'padding-left': '4vw', 'padding-right': '4vw' }"
  [ngClass.lt-md]="'u-textAlign-center'"
>
  <div
    fxLayout="column"
    fxLayout.gt-sm="row wrap"
    [ngStyle]="{
      'max-width': '1280px',
      'padding-left': '1vw',
      'padding-right': '1vw'
    }"
    class="u-margin-center"
  >
    <div
      fxFlex.gt-sm="65"
      fxFlex="50"
      fxFlexOrder.gt-sm="0"
      fxFlexOrder="1"
      class="color-white"
    >
      <app-logo-square
        class="u-display-inlineBlock"
        [ngClass.gt-sm]="'u-marginBottom-40'"
        [ngClass]="'u-marginBottom-24'"
        color="white"
        size="small"
      >
      </app-logo-square>
      <div>Built with &nbsp;❤️&nbsp; in Toronto, Canada.</div>
      <div>Used Worldwide.</div>
    </div>
    <div
      fxFlex.gt-sm="35"
      fxFlex="50"
      fxFlexOrder.gt-sm="1"
      fxFlexOrder="0"
      fxLayout="row"
      fxLayoutAlign.gt-sm="end end"
      fxLayoutAlign="start end"
      [ngClass.lt-md]="'u-marginBottom-24'"
    >
      <div fxFlex.gt-sm="0 0 180px" fxFlex="100%" class="color-white">
        <ng-container *ngFor="let route of routes">
          <div class="u-marginBottom-16">
            <ng-container *ngIf="!!route.href">
              <a
                [href]="route.href"
                (click)="
                  trackInteractionAnalytics({
                    actionType: 'click',
                    targetId: route.targetId
                  })
                "
              >
                <b>{{ route.label }}</b>
              </a>
            </ng-container>
            <ng-container *ngIf="!route.href">
              <a
                [routerLink]="['/' + route.path]"
                (click)="
                  trackInteractionAnalytics({
                    actionType: 'click',
                    targetId: route.targetId
                  })
                "
              >
                <b>{{ route.label }}</b>
              </a>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
